import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApi } from "@/lib/useApi";
import { Loading } from "@/components/RequireAuth";
import ProductForm from "@/pages/seller/ProductForm";

export default function ProductEditor() {
  const { id } = useParams();
  const nav = useNavigate();
  const { data } = useApi(id ? `/seller/products/${id}` : null);
  if (id && !data) return <Loading />;
  const submit = async (payload) => {
    if (id) await api.put(`/seller/products/${id}`, payload);
    else await api.post("/seller/products", payload);
    toast.success(payload.status === "published" ? "Produit publié" : "Brouillon enregistré");
    nav("/vendeur/produits");
  };
  return (
    <div data-testid="product-editor" className="space-y-5">
      <h1 className="font-display text-3xl font-black tracking-tight">{id ? "Modifier le produit" : "Nouveau produit"}</h1>
      <ProductForm initial={data || undefined} onSubmit={submit} />
    </div>
  );
}
